'use client';
import { useEffect } from 'react';
import { X, CheckCircle, AlertCircle, Info } from 'lucide-react';
import styles from './Toast.module.css';

export type ToastType = 'success' | 'error' | 'info';

interface ToastProps {
	message: string;
	type: ToastType;
	onClose: () => void;
	duration?: number;
}

export const Toast = ({ message, type, onClose, duration = 5000 }: ToastProps) => {
	useEffect(() => {
		const timer = setTimeout(onClose, duration);
		return () => clearTimeout(timer);
	}, [duration, onClose]);

	const icons = {
		success: <CheckCircle size={20} />,
		error: <AlertCircle size={20} />,
		info: <Info size={20} />,
	};

	return (
		<div className={`${styles.toast} ${styles[type]}`}>
			<div className={styles.icon}>{icons[type]}</div>
			<p className={styles.message}>{message}</p>
			<button onClick={onClose} className={styles.closeButton} aria-label="Fechar">
				<X size={18} />
			</button>
		</div>
	);
};
